/**
 * Frontend runtime configuration (build-time in Vite).
 *
 * - Prefer `VITE_API_BASE_URL` (used by our CI/CD).
 * - Fall back to legacy `VITE_API_URL` (used in some local setups).
 *
 * Accepted formats:
 * - https://example.com
 * - https://example.com/
 * - https://example.com/api/v1
 * - https://example.com/api/v1/
 *
 * Exported `API_BASE_URL` is always normalized to NOT end with a trailing slash
 * and to include `/api/v1` exactly once.
 */
function normalizeApiBaseUrl(raw: string): string {
  const trimmed = raw.trim().replace(/\/+$/, '')

  if (/\/api\/v1$/i.test(trimmed)) return trimmed

  return `${trimmed}/api/v1`
}

function normalizeStaticBaseUrl(raw: string): string {
  // Remove trailing slashes and /api/v1 suffix
  return raw.trim().replace(/\/+$/, '').replace(/\/api\/v1$/i, '')
}

const rawApiBaseUrl =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ||
  (import.meta.env.VITE_API_URL as string | undefined) ||
  'http://localhost:8000'

export const API_BASE_URL = normalizeApiBaseUrl(rawApiBaseUrl)

export const STATIC_BASE_URL = normalizeStaticBaseUrl(rawApiBaseUrl)

